document.addEventListener("DOMContentLoaded", function () {
    console.log("DOM fully loaded and parsed.");

    const images = document.querySelectorAll("img"); // Select all images
    console.log(`Found ${images.length} images on the page.`);

    images.forEach((img, index) => {
        img.addEventListener("load", function () {
            console.log(`Image ${index + 1} loaded: ${img.src}`);

            const canvas = document.createElement("canvas");
            const context = canvas.getContext("2d", { willReadFrequently: true });

            canvas.width = img.naturalWidth;
            canvas.height = img.naturalHeight;

            console.log("Canvas created for image:", img.src);

            context.drawImage(img, 0, 0, img.naturalWidth, img.naturalHeight);
            console.log("Image drawn to canvas successfully.");

            try {
                const whitePixelThreshold = 10; // Number of consecutive white pixels needed per side
                let isTopWhite = true;
                let isBottomWhite = true;
                let isLeftWhite = true;
                let isRightWhite = true;

                const isWhitePixel = (r, g, b) => r === 255 && g === 255 && b === 255; // Strict pure white check

                // Check top border
                for (let x = 0; x < whitePixelThreshold; x++) {
                    const pixelData = context.getImageData(x, 0, 1, 1).data;
                    if (!isWhitePixel(pixelData[0], pixelData[1], pixelData[2])) {
                        isTopWhite = false;
                        break;
                    }
                }

                // Check bottom border
                for (let x = 0; x < whitePixelThreshold; x++) {
                    const pixelData = context.getImageData(x, img.naturalHeight - 1, 1, 1).data;
                    if (!isWhitePixel(pixelData[0], pixelData[1], pixelData[2])) {
                        isBottomWhite = false;
                        break;
                    }
                }

                // Check left border
                for (let y = 0; y < whitePixelThreshold; y++) {
                    const pixelData = context.getImageData(0, y, 1, 1).data;
                    if (!isWhitePixel(pixelData[0], pixelData[1], pixelData[2])) {
                        isLeftWhite = false;
                        break;
                    }
                }

                // Check right border
                for (let y = 0; y < whitePixelThreshold; y++) {
                    const pixelData = context.getImageData(img.naturalWidth - 1, y, 1, 1).data;
                    if (!isWhitePixel(pixelData[0], pixelData[1], pixelData[2])) {
                        isRightWhite = false;
                        break;
                    }
                }

                // Apply filter if all sides have 10 pure white pixels
                if (isTopWhite && isBottomWhite && isLeftWhite && isRightWhite) {
                    img.style.filter = "brightness(0.9) contrast(1.2)";
                    console.log("Filter applied to image:", img.src);
                } else {
                    console.log("No filter applied: Not all sides have enough white pixels.");
                }
            } catch (error) {
                console.error("Error reading pixel data for:", img.src, error);
            }
        });
    });
});
